import request from '@utils/request'
import { ParamsProps, ReturnType } from './types'

const catalogue = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: 'smm-orders/catalogue',
      method: 'get',
      authorization: true,
      config: {
        showErr: true,
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const create = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: 'smm-orders/curated',
      method: 'post',
      authorization: true,
      data: args?.data,
      config: {
        successMsg: 'Service Added',
        showErr: true,
        store: {
          key: args?.state,
          action: 'prepend',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const update = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `smm-orders/curated/${args?.id}`,
      method: 'patch',
      authorization: true,
      data: args?.data,
      config: {
        successMsg: 'Updated Successfully',
        showErr: true,
        store: {
          key: args?.state,
          action: 'update',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const remove = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `smm-orders/curated/${args?.id}`,
      method: 'delete',
      authorization: true,
      config: {
        successMsg: 'Removed Successfully',
        showErr: true,
        store: {
          key: args?.state,
          action: 'remove',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: 'smm-orders/curated',
      method: 'get',
      params: args.params,
      authorization: true,
      config: {
        showErr: true,
      },
    }
    if (args.state) {
      config.config.store = {
        key: args?.state,
        action: 'set',
      }
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const selectedCategories = async () => {
  try {
    const config: ReturnType = {
      url: 'smm-orders/selected-categories',
      method: 'get',
      authorization: true,
      config: {
        showErr: true,
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const addSelectedCategory = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: 'smm-orders/selected-categories',
      method: 'post',
      authorization: true,
      data: args?.data,
      config: {
        successMsg: 'Category Added',
        showErr: true,
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const updateSelectedCategoryImage = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `smm-orders/selected-categories/${args?.id}`,
      method: 'patch',
      authorization: true,
      data: args?.data,
      config: {
        successMsg: 'Image Updated',
        showErr: true,
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const getRateMultiplier = async () => {
  try {
    const config: ReturnType = {
      url: 'smm-orders/rate-multiplier',
      method: 'get',
      authorization: true,
      config: {
        showErr: true,
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const updateRateMultiplier = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: 'smm-orders/rate-multiplier',
      method: 'patch',
      authorization: true,
      data: args?.data,
      config: {
        successMsg: 'Rate Multiplier Updated',
        showErr: true,
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const removeSelectedCategory = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `smm-orders/selected-categories/${args?.id}`,
      method: 'delete',
      authorization: true,
      config: {
        successMsg: 'Category Removed',
        showErr: true,
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

export default {
  catalogue,
  create,
  update,
  remove,
  list,
  selectedCategories,
  addSelectedCategory,
  updateSelectedCategoryImage,
  removeSelectedCategory,
  getRateMultiplier,
  updateRateMultiplier,
}
